import checkoutRoutes from './checkout.routes';

import paymentController from './controllers/payment.controller';
import checkoutController from './controllers/checkout.controller';
import customiseController from './controllers/customise.controller';
import optionsController from './controllers/options.controller';
import suggestionsController from './controllers/suggestions.controller';
import reviewController from './controllers/review.controller';
import stepsController from './controllers/steps.controller';
import navigationController from './controllers/navigation.controller';

import paymentComponent from './components/payment.component';
import checkoutComponent from './components/checkout.component';
import customiseComponent from './components/customise.component';
import optionsComponent from './components/options.component';
import suggestionsComponent from './components/suggestions.component';
import reviewComponent from './components/review.component';
import stepsComponent from './components/steps.component';
import navigationComponent from './components/navigation.component';
import storePaymentErrorsComponent from './components/store.payment.errors.component';

import checkoutService from './services/checkout.service';
import checkoutValidationService from './services/checkout.validation.service';
import optionExtrasService from './services/optionExtras.service';
import throttleService from './services/throttle.service';
import upgradeService from './services/upgrade.service';
import suggestionsApiService from './services/suggestions.api.service';
import promoApiService from './services/promo.api.service';
import voucherApiService from './services/voucher.api.service';
import navigationService from './services/navigation.service';

let checkoutModule = angular.module('spabooker.checkout', [ 'ngMask' ])
  .config(checkoutRoutes)

  .controller('paymentController', paymentController)
  .controller('checkoutController', checkoutController)
  .controller('customiseController', customiseController)
  .controller('optionsController', optionsController)
  .controller('suggestionsController', suggestionsController)
  .controller('reviewController', reviewController)
  .controller('stepsController', stepsController)
  .controller('navigationController', navigationController)

  .component('payment', paymentComponent)
  .component('checkout', checkoutComponent)
  .component('customise', customiseComponent)
  .component('options', optionsComponent)
  .component('suggestions', suggestionsComponent)
  .component('review', reviewComponent)
  .component('steps', stepsComponent)
  .component('navigation', navigationComponent)
  .component('storePaymentErrors', storePaymentErrorsComponent)

  .factory('checkout', checkoutService)
  .factory('checkoutValidationService', checkoutValidationService)
  .factory('optionExtrasService', optionExtrasService)
  .factory('throttleService', throttleService)
  .factory('upgradeService', upgradeService)
  .factory('suggestionsApiService', suggestionsApiService)
  .factory('promoApiService', promoApiService)
  .factory('voucherApiService', voucherApiService)
  .factory('navigationService', navigationService)

  .run([ 'configService', 'paymentGatewayService', (configService, paymentGatewayService) => {
    const config = configService.get('gateways');

    if (paymentGatewayService && config) {
      paymentGatewayService.load(config);
    }
  } ]);
export default checkoutModule.name;



// WEBPACK FOOTER //
// ./frontend/storefront/app/modules/checkout/index.js